import { Splide } from "@splidejs/splide";

import './news-carousel.scss';

export class NewsCarousel {

	wrapper: HTMLElement;
	carousel: any;
	options: any;
	customOptions: any;
	prev: HTMLButtonElement;
	next: HTMLButtonElement;


	constructor(wrapper: HTMLElement) {
		this.wrapper = wrapper.closest('.news-carousel-wrapper');
		this.prev    = this.wrapper.querySelector('.splide__arrows .splide__arrow--prev');
		this.next    = this.wrapper.querySelector('.splide__arrows .splide__arrow--next');

		this.customOptions = this.wrapper.dataset.splideOptions ? JSON.parse(this.wrapper.dataset.splideOptions) : {};

		this.options = {
			type   : 'slide',
			perPage: 1,
			focus  : 'center',
			arrows: false,
			pagination: false,
			speed: 1200,
			easing: 'cubic-bezier(.55, 0, .55, 1)',
			autoplay: false,
			// padding: '20px',
			breakpoints: {
				767: {
					perPage: 1,
				},
				1023: {
					perPage: 2,
					focus: 'left',
					gap: 20
				},
				1439: {
					perPage: 2,
					focus: 'left',
					gap: 30
				},
				8192: {
					autoWidth: true,
					focus: 'left',
					gap: 30
				},
			},
			...this.customOptions
		};

		this.carousel = new Splide( <HTMLElement>this.wrapper.querySelector('.news-carousel'), this.options ).mount();

		if ( this.prev ) {
			this.prev.addEventListener('click', (ev: MouseEvent) => {
				ev.preventDefault();
				this.carousel.go('<');
			});
		}

		if ( this.next ) {
			this.next.addEventListener('click', (ev: MouseEvent) => {
				ev.preventDefault();
				this.carousel.go('>');
			});
		}
	}

}


